export default [
  {
    name: "firstName",
    title: 'First Name',
    width: "60%",
    sortField: "firstName",
    formatter(value) {
      if (value) {
        return value;
      } else {
        return '--';
      }
    }
  },
  {
    name: "lastName",
    title: 'Last Name',
    width: "10%",
    sortField: "lastName",
    formatter(value) {
      if (value) {
        return value;
      } else {
        return '--';
      }
    }
  },
  {
    name: "email",
    title: 'Email',
    width: "10%",
    sortField: "email",
    formatter(value) {
      if (value) {
        return value;
      } else {
        return '--';
      }
    }
  },
  {
    name: "phone",
    title: 'Phone Number',
    width: "10%",
    sortField: "email",
    formatter(value) {
      if (value) {
        return value;
      } else {
        return '--';
      }
    }
  },
  {
    name: "isActive",
    title: 'Email',
    width: "350px",
    visible:false
  },
  {
    name: "is_manager",
    title: 'Manager',
    width: "10%"
  },
  {
    name: "is_active",
    title: 'Active',
    width: "10%"
  }

]